/* eslint-disable no-magic-numbers */
import cookies from 'js-cookie';
import config from '../config/user.env';
import { Logout } from '@/modules/index/api/user';
import store from '@/store/index';
import './imgErrorListener';
import bigDataLog from '@/utils/bigDataLog';
import bigDataConfig from '@/bigData/index';
/**
 * 注入dialog拖拽指令、缩放指令
 */
import './directives';
import './loadMore';
/**
 * 退出登录
 */
export const logout = async (flag = false) => {
    cookies.remove('OAM_ID', { domain: '.annto.com' });
    await Logout();
    sessionStorage.removeItem("messageState");
    sessionStorage.removeItem("rectifyNotice");
    sessionStorage.removeItem("arbitrationNotice");
    sessionStorage.removeItem("bidMessageState");
    const sourcePage = window.location.href;
    const loginUrl = config.singlePointLogin + encodeURI(sourcePage);
    if (flag) {
        window.location.href = config.singlePointLogout + loginUrl;
    } else {
        window.location.href = loginUrl;
    }
};

/**
 * 判断是否登录
 * @param {*} router 路由
 */
export function checkLogin(router, whiteList) {
    router.beforeEach((to, from, next) => {
        if (whiteList && whiteList.indexOf(to.path) !== -1) {
            next();
        } else {
            const { userCode } = store.getters.user;
            if (userCode) {
                // 各页面添加各自大数据埋点变量
                window.bigDataConfig = bigDataConfig[to.name] || {};
                try{ bigDataLog.sendDetailMessageByRoute(to) } catch (error) {}
                next();
            } else {
                store.dispatch('initSystem').then(res => {
                    if (res) {
                        // 各页面添加各自大数据埋点全局变量
                        window.bigDataConfig = bigDataConfig[to.name] || {};
                        try{ bigDataLog.sendDetailMessageByRoute(to) } catch (error) {}
                        // 系统初始化成功后，记录用户访问次数
                        bigDataLog.sendMainMessage();
                        next();
                    }
                });
            }
        }
    });
}

export function parseTime(time, cFormat) {
    if (arguments.length === 0) {
        return null;
    }
    const date = new Date(time);
    let fmt = cFormat || 'yyyy-MM-dd hh:mm:ss';
    const o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3) // 季度
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    Object.keys(o).forEach(k => {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
        }
    });
    return fmt;
}

export function linkRedirect() {
    const { href } = window.location;
    if (href.includes('.midea.com')) {
        const anntoHref = href.replace('.midea.com', '.annto.com');
        window.location.href = anntoHref;
    }
}
